import { render, staticRenderFns } from "./Natjecatelj.vue?vue&type=template&id=a3e08188&scoped=true&"
import script from "./Natjecatelj.vue?vue&type=script&lang=js&"
export * from "./Natjecatelj.vue?vue&type=script&lang=js&"
import style0 from "./Natjecatelj.vue?vue&type=style&index=0&id=a3e08188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e08188",
  null
  
)

export default component.exports